export default __webpack_public_path__ + "static/media/Flaticon.1d95ae0b.svg";